export default {
  "content": "<path d=\"M29.017 17.25L18 7.75l-11 9.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M9.75 15v13.25h16.5V15.297\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M15.024 27.944v-7.918h5.98v7.918M21.75 10.656V8h4.5v7.297\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "viewBox": "0 0 36 36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};